import { USER_KEY2 } from "./index";

// ສິດຍ່ອຍ ເພີ່ມ/ແກ້ໄຂ/ລົບ — ຕົວຫຼັກ (PRODUCTS/ORDERS) = ເຂົ້າເບິ່ງໜ້າ
const CRUD_ACTIONS = [
  ["CREATE", "ເພີ່ມ"],
  ["UPDATE", "ແກ້ໄຂ"],
  ["DELETE", "ລົບ"],
];
const crudChildren = (parent) =>
  CRUD_ACTIONS.map(([action, name]) => ({ value: `${parent}_${action}`, name }));

// Keep keys in sync with CF_PERMISSIONS in 4b-cf-api/src/resolvers/role/helper.js
export const CF_PERMISSION_GROUPS = [
  // Same order and sections (split at the <hr />s) as the menu in layouts/SideNav.js
  {
    title: "ລາຍງານ ແລະ ການຂາຍ",
    items: [
      { value: "DASHBOARD", name: "ສະຖິຕິ" },
      { value: "TOTAL_SUMMARY", name: "ສະຫລຸບຍອດ" },
      { value: "LIVE_MANAGE", name: "Live Streaming" },
      { value: "POST_FEED", name: "Post" },
      { value: "MESSENGER_INBOX", name: "Chat" },
      { value: "SALE_PAGE", name: "ເຊວເພຈ (ແບນເນີ, ໃບເກັບເງິນ, Affiliate, ສະຖິຕິ)" },
    ],
  },
  {
    title: "ຈັດການຂໍ້ມູນ",
    items: [
      { value: "PRODUCTS", name: "ຈັດການສິນຄ້າ", children: crudChildren("PRODUCTS") },
      { value: "ORDERS", name: "ຈັດການອໍເດີ້", children: crudChildren("ORDERS") },
      { value: "CUSTOMERS", name: "ຈັດການຂໍ້ມູນລູກຄ້າ (ລວມ ເບີ/ທີ່ຢູ່ຈາກແຊັດ)" },
      { value: "WALLET", name: "ກະເປົາຂອງຂ້ອຍ" },
    ],
  },
  // One item per card on pages/settings/Settings.js, in the order they appear there.
  {
    title: "ຕັ້ງຄ່າ",
    items: [
      { value: "SETTING_FACEBOOK", name: "ຕັ້ງຄ່າຂໍ້ຄວາມຕອບກັບ" },
      { value: "SETTING_BANK", name: "ຕັ້ງຄ່າບັນຊີທະນາຄານ" },
      { value: "SETTING_LIVE", name: "ຕັ້ງຄ່າໄລຟ" },
      { value: "SETTING_OPTION_VALUE", name: "ຕົວເລືອກຈັດການສິນຄ້າ" },
      { value: "SETTING_TAG", name: "ຕັ້ງຄ່າເທັກ" },
      { value: "SETTING_EXCHANGE_RATE", name: "ຕັ້ງຄ່າເລດເງິນ" },
      { value: "SETTING_BILL", name: "ຕັ້ງຄ່າບິນ" },
      { value: "SETTING_LOGISTICS", name: "ຕັ້ງຄ່າຂົນສົ່ງ" },
      { value: "SETTING_TTS", name: "Text To Speech" },
      { value: "SETTING_OTHER", name: "ຕັ້ງຄ່າອື່ນ" },
      { value: "SETTING_AFFILIATE", name: "Affiliater" },
      { value: "SETTING_PROFILE", name: "ໂປຣຟາຍຮ້ານ" },
      { value: "STAFF_MANAGEMENT", name: "ຈັດການພະນັກງານ ແລະ ສິດ" },
    ],
  },
];

export const CF_PERMISSIONS = CF_PERMISSION_GROUPS.flatMap((g) =>
  g.items.flatMap((i) => [i.value, ...(i.children || []).map((c) => c.value)]),
);

//* ບົດບາດທີ່ບັນທຶກກ່ອນມີສິດຍ່ອຍ (ບໍ່ມີ CRUD_SCOPED) → ຖືວ່າໄດ້ ເພີ່ມ/ແກ້ໄຂ/ລົບ ຄົບ
//* ຄືກັບ withLegacyCrud ໃນ 4b-cf-api — ກັນ session ເກົ່າທີ່ cache ສິດໄວ້ກ່ອນ deploy
const CRUD_SCOPED = "CRUD_SCOPED";
export const withLegacyCrud = (permissions = []) => {
  if (permissions.includes(CRUD_SCOPED)) return permissions;
  const extra = ["PRODUCTS", "ORDERS"]
    .filter((p) => permissions.includes(p))
    .flatMap((p) => CRUD_ACTIONS.map(([action]) => `${p}_${action}`));
  return [...new Set([...permissions, ...extra])];
};

// Anyone holding at least one settings item may open the /settings page itself.
export const SETTINGS_PAGE_PERMISSIONS = CF_PERMISSION_GROUPS.find(
  (g) => g.title === "ຕັ້ງຄ່າ",
).items.map((i) => i.value);

// Exact paths win over prefixes. An array means any one of them is enough.
const EXACT_PATH_PERMISSIONS = {
  "/settings": SETTINGS_PAGE_PERMISSIONS,
  "/settings-facebook": "SETTING_FACEBOOK",
  "/settings-bank": "SETTING_BANK",
  "/settings-live": "SETTING_LIVE",
  "/settings-option-value": "SETTING_OPTION_VALUE",
  "/settings-tag": "SETTING_TAG",
  "/exchange-rate": "SETTING_EXCHANGE_RATE",
  "/settting-bills": "SETTING_BILL",
  "/logictics": "SETTING_LOGISTICS",
  "/tts-cloud": "SETTING_TTS",
  "/setting-other": "SETTING_OTHER",
  "/setting-app-v2": "SETTING_OTHER",
  "/settings-profile": "SETTING_PROFILE",
  "/settings-staff": "STAFF_MANAGEMENT",
};

// First path segment (before any "/") → permission. Unlisted paths need none.
const PATH_PREFIX_PERMISSIONS = [
  ["/dashboard", "DASHBOARD"],
  ["/total-summary", "TOTAL_SUMMARY"],
  ["/live-", "LIVE_MANAGE"],
  ["/like-select-page", "LIVE_MANAGE"],
  ["/post-", "POST_FEED"],
  ["/messenger-inbox", "MESSENGER_INBOX"],
  //* ໜ້າ ເພີ່ມ/ແກ້ໄຂ ຕ້ອງມີສິດຍ່ອຍ — ຕ້ອງຢູ່ກ່ອນ prefix ທົ່ວໄປ ("/product-")
  //* "/orders-add" ໃຊ້ທັງສ້າງ ແລະ ແກ້ໄຂ (editMode) → ກັ້ນຢູ່ໃນໜ້າ OrderAddV2 ແທນ
  ["/product-add", "PRODUCTS_CREATE"],
  ["/product-exceal-add", "PRODUCTS_CREATE"],
  ["/product-edit", "PRODUCTS_UPDATE"],
  ["/orderlistEdit", "ORDERS_UPDATE"],
  ["/products", "PRODUCTS"],
  ["/product-", "PRODUCTS"],
  ["/productmanager", "PRODUCTS"],
  ["/orders", "ORDERS"],
  ["/ordergroupdetail", "ORDERS_UPDATE"], //* ໜ້າເກົ່າ ແກ້ໄຂ/ລົບລາຍການໃນບິນ

  ["/orderprint", "ORDERS"],
  ["/ordermove", "ORDERS"],
  ["/stored_delivery", "ORDERS"],
  ["/user-cf", "CUSTOMERS"],
  ["/customer-cf-", "CUSTOMERS"],
  ["/contact-drafts", "CUSTOMERS"],
  ["/wallet_store", "WALLET"],
  ["/setting-salepage", "SALE_PAGE"],
  ["/advertising-sale-page", "SALE_PAGE"],
  ["/invoices", "SALE_PAGE"],
  ["/infulancer", "SALE_PAGE"],
  ["/commision-form", "SALE_PAGE"],
  ["/view-stats", "SALE_PAGE"],
];

// Where to send someone whose landing page they may not open, in menu order.
const LANDING_PATHS = [
  ["DASHBOARD", "/dashboard"],
  ["TOTAL_SUMMARY", "/total-summary"],
  ["LIVE_MANAGE", "/live-manage/active/limit/50/page/1"],
  ["POST_FEED", "/post-feed"],
  ["MESSENGER_INBOX", "/messenger-inbox"],
  ["SALE_PAGE", "/invoices"],
  ["PRODUCTS", "/products/limit/50/page/1"],
  ["ORDERS", "/orders/limit/50/page/1"],
  ["CUSTOMERS", "/customer-cf-list"],
  ["WALLET", "/wallet_store/limit/50/page/1"],
  ...SETTINGS_PAGE_PERMISSIONS.map((p) => [p, "/settings"]),
];

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY2) || "null")?.data || null;
  } catch (e) {
    return null;
  }
};

/**
 * Only staff created in "ຈັດການພະນັກງານ ແລະ ສິດ" are restricted. role STAFF is not enough:
 * ~1,500 older shop logins carry role STAFF with no platform, and they are the shop itself.
 * A CF staff has platform CF and always holds a CF role; the role check also covers sessions
 * that signed in before `platform` was part of the login response.
 */
const isCfStaff = (user) =>
  user?.role === "STAFF" && (user?.platform === "CF" || user?.permission?.platform === "CF");

export const isRestrictedUser = () => isCfStaff(readUser());

export const getUserPermissions = () => {
  const user = readUser();
  if (!isCfStaff(user)) return CF_PERMISSIONS;
  const role = user?.permission;
  //* A staff account carrying a POS role gets nothing here — POS roles are not CF roles.
  if (!role || role.platform !== "CF") return [];
  return Array.isArray(role.permissions) ? withLegacyCrud(role.permissions) : [];
};

export const hasPermission = (permission) => {
  if (!permission) return true;
  const permissions = getUserPermissions();
  return Array.isArray(permission)
    ? permission.some((p) => permissions.includes(p))
    : permissions.includes(permission);
};

export const getPathPermission = (path = "") => {
  if (EXACT_PATH_PERMISSIONS[path]) return EXACT_PATH_PERMISSIONS[path];
  const match = PATH_PREFIX_PERMISSIONS.find(([prefix]) => path.startsWith(prefix));
  return match ? match[1] : null;
};

export const canAccessPath = (path) => hasPermission(getPathPermission(path));

export const getFirstAllowedPath = () => {
  const permissions = getUserPermissions();
  const found = LANDING_PATHS.find(([p]) => permissions.includes(p));
  return found ? found[1] : null;
};

//* ແຈ້ງໜ້າທີ່ເປີດຢູ່ ໃຫ້ອ່ານສິດໃໝ່ (ເບິ່ງ helpers/usePermission.js)
export const PERMISSION_CHANGED_EVENT = "cf-permission-changed";

/** Replace the cached role after a refresh, keeping the rest of USER_DATA. */
export const updateStoredPermission = (permission) => {
  try {
    const stored = JSON.parse(localStorage.getItem(USER_KEY2) || "null");
    if (!stored?.data) return;
    stored.data.permission = permission;
    localStorage.setItem(USER_KEY2, JSON.stringify(stored));
    window.dispatchEvent(new Event(PERMISSION_CHANGED_EVENT));
  } catch (e) {
    // ignore — the next login refreshes it anyway
  }
};
